// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"410":"80e715ac","558":"3f37a95d","598":"ff06c99b"}[chunkId] + ".chunk.css";
};